import { css } from "@emotion/react";
import { duration } from "./semantic/animation";
import { borderRadius } from "./semantic/shape";
import { text, surface } from "./semantic/colors";
import { spacing } from "./semantic/spacing";
import { colorPrimitives } from "./primitives/colors";
import { fadeIn } from "./animations";

export const flexCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const flexCenterColumn = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const textTruncate = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const visuallyHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const noOutlineOnFocus = css`
  &:focus:not(:focus-visible) {
    outline: none;
  }
`;

export const fadeInAnimation = css`
  opacity: 0;
  animation: ${fadeIn} ${duration.base} linear 1 forwards;
`;

export interface RadioButtonProps {
  $checked: boolean;
}

export const radioButtonCss = ({ $checked }: RadioButtonProps) => css`
  display: flex;
  align-items: center;
  position: relative;

  &:before {
    content: "";
    width: 12px;
    height: 12px;
    border-radius: ${borderRadius.pill};
    border: solid 1px ${text.primary};
    margin-right: ${spacing[2]};
    flex-shrink: 0;
  }

  &:after {
    ${$checked ? "content: '';" : "content: none;"}
    width: 6px;
    height: 6px;
    border-radius: ${borderRadius.pill};
    background-color: ${text.primary};
    transform: translate(4px, 0);
    position: absolute;
    flex-shrink: 0;
  }

  &:hover {
    background-color: ${surface.hover};
    color: ${colorPrimitives.backgroundDark};

    &:before {
      border-color: ${colorPrimitives.backgroundDark};
    }

    &:after {
      background-color: ${colorPrimitives.backgroundDark};
    }
  }
`;
